import {
  IconMapHighway16,
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  IconMapTrain16,
} from '@cian/ui-kit-design-tokens/icons';
import { useMemo } from 'react';
import { TIconType } from '../../../../types/layouts/underground';
import * as styles from './style.css';

interface IUndergroundIconProps {
  type: TIconType;
  color: string;
}

export const UndergroundIcon = ({ type, color }: IUndergroundIconProps) => {
  const TransportIcon = useMemo(() => {
    switch (type) {
      case 'spb':
        return IconMapMetroSpb16;
      case 'ekb':
        return IconMapMetroEkb16;
      case 'kzn':
        return IconMapMetroKzn16;
      case 'nsk':
        return IconMapMetroNovosib16;
      case 'smr':
        return IconMapMetroSam16;
      case 'nn':
        return IconMapMetroNN16;
      case 'highway':
        return IconMapHighway16;
      case 'railway':
        return IconMapTrain16;
      case 'mow':
      default:
        return IconMapMetroMsk16;
    }
  }, [type]);

  const style = useMemo(() => ({ color: `#${color}` }), [color]);

  return (
    <div className={styles['container']} style={style}>
      <TransportIcon color="current_color" />
    </div>
  );
};
